import { translateKey } from 'src/locales/translate';
import { WarehouseUnit } from 'woofwoof-api';
import { UnitLabels, formatStock } from './quantity';

export interface StockDisplayProduct {
  unit: WarehouseUnit;
  unitCustom?: string;
  unitsPerPackage: number;
}

export function unitLabelsFor(
  product: Pick<StockDisplayProduct, 'unit' | 'unitCustom'>,
): UnitLabels {
  if (product.unit === 'OTHER' && product.unitCustom) {
    const name = product.unitCustom;
    return { one: name, few: name, many: name, fraction: name };
  }
  const base = `warehouse.units.${product.unit}`;
  return {
    one: translateKey(`${base}.one`),
    few: translateKey(`${base}.few`),
    many: translateKey(`${base}.many`),
    fraction: translateKey(`${base}.fraction`),
  };
}

export function formatProductStock(
  quantityMilli: number,
  product: StockDisplayProduct,
): string {
  return formatStock(
    quantityMilli,
    product.unitsPerPackage,
    unitLabelsFor(product),
    translateKey('warehouse.common.packageShort'),
  );
}
